import { Donuz } from "donuz-js/Donuz";
// @ is an alias to /src
export default {
  name: "contct",
  data() {
    return {
      obj: {},
      name: "",
      phone: "",
      email: "",
      contact: {
        subject: "",
        message: ""
      }
    };
  },
  async created() {
    this.obj = await this.getAdmins();
    this.obj = this.obj.estabelecimentos[0];
  },
  methods: {
    submit: async function() {
      let msg = `<div style="background-color:#771b7c;padding:30px;">
                                     <div style="width:650px;margin:auto;">
                                         <div style="background-color:#fff;padding:20px;color:#333;">
                                             <h3>${this.obj.nome} - CONTATO</h3>
                                             <p><strong>Nome:</strong> ${
                                               this.name
                                             } </p>
                                             <p><strong>Email:</strong> ${
                                               this.email
                                             } '</p>
                                             <p><strong>Telefone:</strong> ${
                                               this.phone
                                             }</p>
                                             <p><strong>Mensagem:</strong> ${
                                               this.contact.message
                                             }</p>
                                         </div>
                                     </div>
                                </div>`;
      let result = await Donuz.mail.sendMail({
        to: this.obj.email,
        assunto: this.contact.subject,
        mensagem: msg
      });
      if (result.status == 200) {
        M.toast({ html: result.mensagem, classes: "green" });
      } else {
        M.toast({
          html: "Não coseguimos enviar corretamento o email. Tente novamente",
          classes: "red"
        });
      }
    }
  }
};
